import CreateGamer from "components/Partner/CreateGamer";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Translation } from "react-i18next";

import "swiper/css";
import "swiper/css/pagination";

import Pick777 from "components/Gamer/Pick777";
import Casino from "components/Gamer/Casino";
import LiveCasino from "components/Gamer/LiveCasino";
import Games from "components/Gamer/Games";
import Virtual from "components/Gamer/Virtual";


import Norok from "components/Gamer/Norok";
import MatGame from "components/Gamer/MatGame";
import Innova from "components/Gamer/Innova";

import Pragmatic from "components/Gamer/Pragmatic";
import SmartSoft from "components/Gamer/SmartSoft";
import { gameAction } from "_actions";
import { GameService } from "_services";
import Blas975 from "components/Gamer/Blas975";
import Live from "components/Gamer/Live";
import MyAccount from "components/Gamer/MyAccount";
import WorldMatch from "components/Gamer/WorldMatch";
import Detroit from "components/Gamer/Detroit";
import TimelessTech from "components/Gamer/TimelessTech";

import Home from "components/Gamer/Home";
import TVGames from "components/Gamer/TVGames";
import { SiteFeatures } from "config/siteFeatures";
import Sportsbook from "components/Gamer/Sportsbook";
import LiveSports from "components/Gamer/Sportsbook/LiveSports";
import Gasea from "components/Gamer/Gasea";
import Bonus from "components/Gamer/Bonus";
import Rules from "components/Gamer/Rules";
import MaxWinLimits from "components/Gamer/MaxWinLimits";
import Contact from "components/Gamer/Contact";

const Gamer = (props) => {
  const { UpdateGames, UpdateLiveGame, UpdateLoadingStatus } = props;
  const [startPage, setStartPage] = useState("/");

  const getGames = () => {
    GameService.GET_GAMES_WITH_FILTER(["pragmatic", "evolution"], 1, 100)
      .then((res) => {
        const newData = res.map((x) => {
          let y = x;
          if (x.middleware == "blas975") {
            y.CacheData = x.CacheData.reverse();
            return y;
          } else {
            return x;
          }
        });
        UpdateGames(res);
        getAllGames()
      })
      .catch((err) => {
        debugger;
        UpdateLoadingStatus(false);
      });
  };

  const getAllGames = async () => {
    await GameService.GET_GAMES()
      .then((res) => {

        UpdateGames(res);
        UpdateLoadingStatus(false);
      })
      .catch((err) => {
        debugger;
        UpdateLoadingStatus(false);

      });
  };
  const getLiveGames = () => {
    GameService.GET_LIVE_GAMES()
      .then((res) => {
        UpdateLiveGame(res);
        //UpdateGames(res);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    UpdateLoadingStatus(true);
    getGames();
    getLiveGames();

  }, []);

  useEffect(() => {
    if (!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) {

      setStartPage("/");
    } else {
      if (props.permissions) {
        if (
          props.permissions?.SPORTS_ACCESS &&
          props.permissions?.SPORTS_ACCESS?.Value
        ) {
          if (startPage != "/sports") setStartPage("/sports");
        } else

          if (
            props.permissions?.CASINO_ACCESS &&
            props.permissions?.CASINO_ACCESS?.Value
          ) {
            if (startPage != "/casino") setStartPage("/casino");
          } else if (
            props.permissions?.LIVECASINO_ACCESS &&
            props.permissions?.LIVECASINO_ACCESS?.Value
          ) {
            setStartPage("/live-casino");
          } else if (
            props.permissions?.GAMES_ACCESS &&
            props.permissions?.GAMES_ACCESS?.Value
          ) {
            setStartPage("/games");
          } else if (
            props.permissions?.VIRTUAL_ACCESS &&
            props.permissions?.VIRTUAL_ACCESS?.Value
          ) {
            setStartPage("/virtual");
          } else if (
            props.permissions?.TVGAMES_ACCESS &&
            props.permissions?.TVGAMES_ACCESS?.Value
          ) {
            setStartPage("/tv-games/");
          } else {
            //setStartPage("/my-account/");
          }
      }
    }
  }, [props.permissions, startPage]);

  return (
    <Translation>
      {(t) => (
        <>
          <Routes key={startPage}>
            <Route path="*" element={<Navigate to={startPage} />} />


            {
              ((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.SPORTS_ACCESS?.Value) && (
                <Route index path="/sports" element={<Sportsbook />} />
              )
            }

            {
              ((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.SPORTS_ACCESS?.Value) && (
                <Route index path="/sports/live" element={<LiveSports />} />
              )
            }

            {
              ((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.HOME_ACCESS?.Value) && (
                <Route index path="/" element={<Home />} />
              )
            }

            {false && SiteFeatures.BONUS_SYSTEM && (
              <Route path="/bonus" element={<Bonus />} />
            )}
            <Route path="/rules" element={<Rules />} />
            <Route path="/max-win-limits" element={<MaxWinLimits />} />
            <Route path="/contact-us" element={<Contact />} />



            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.CASINO_ACCESS?.Value) && (
              <>
                <Route path="/casino" element={<Casino />} />
                <Route path="/casino/:ProviderId" element={<Casino />} />
              </>
            )}


            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.LIVECASINO_ACCESS?.Value) && (
              <>
                <Route path="/live-casino" element={<LiveCasino />} />
                <Route path="/live-casino/:ProviderId" element={<LiveCasino />} />
              </>
            )}
            {/*
            props.permissions?.LIVECASINO_ACCESS?.Value && (
              <>
                {props?.permissions?.PRAGMATIC_LIVECASINO_ACCESS?.Value ? (
                  <Route
                    path="/live-casino"
                    element={<Navigate to="/live-casino/537" />}
                  />
                ) : (
                  <Route path="/live-casino/" element={<LiveCasino />} />
                )}

                <Route
                  path="/live-casino/:ProviderId"
                  element={<LiveCasino />}
                />
              </>
            )*/}

            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.GAMES_ACCESS?.Value) && (
              <>
                <Route path="/games" element={<Games />} />
                <Route path="/games/:ProviderId" element={<Casino />} />
              </>
            )}

            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.VIRTUAL_ACCESS?.Value) && (
              <>
                <Route path="/virtual" element={<Virtual />} />

                <Route path="/virtual/:ProviderId" element={<Casino />} />
              </>
            )}

            {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || props.permissions?.TVGAMES_ACCESS?.Value) && (
              <>
                <Route path="/tv-games" element={<TVGames />} />
                <Route path="/tv-games/:ProviderId" element={<TVGames />} />
              </>
            )}

            {
              props.loggedIn && (
                <>

                  <Route path="/pragmatic/:GameId" element={<Pragmatic />} />
                  <Route path="/norok/:ProviderId/:GameId" element={<Norok />} />
                  <Route path="/matgame/:ProviderId/:GameId" element={<MatGame />} />
                  <Route path="/innova/:ProviderId/:GameId" element={<Innova />} />
                  <Route path="/gasea/:ProviderId/:GameId" element={<Gasea />} />
                  <Route path="/nonamehero/:ProviderId/:GameId" element={<Blas975 />} />


                  {/*            <Route path="/pragmatic/:GameId" element={<Pragmatic />} />*/}
                  <Route
                    path="/WorldMatch/:ProviderId/:GameId"
                    element={<WorldMatch demo={false} />}
                  />
                  <Route
                    path="/WorldMatch-demo/:ProviderId/:GameId"
                    element={<WorldMatch demo={true} />}
                  />

                  <Route path="/live/:GameId" element={<Live demo={false} />} />

                  <Route
                    path="/pragmatic-demo/:GameId"
                    element={<Pragmatic demo={true} />}
                  />
                  <Route
                    path="/smartsoft/:GameId"
                    element={<SmartSoft demo={false} />}
                  />
                  <Route
                    path="/smartsoft-demo/:GameId"
                    element={<SmartSoft demo={true} />}
                  />
                  <Route
                    path="/blas975/:ProviderId/:GameId"
                    element={<Blas975 demo={false} />}
                  />
                  <Route
                    path="/blas975-demo/:ProviderId/:GameId"
                    element={<Blas975 demo={true} />}
                  />
                  <Route
                    path="/detroit/:ProviderId/:GameId"
                    element={<Detroit demo={false} />}
                  />
                  <Route
                    path="/detroit-demo/:ProviderId/:GameId"
                    element={<Detroit demo={true} />}
                  />

                  <Route
                    path="/timelesstech/:ProviderId/:GameId"
                    element={<TimelessTech demo={false} />}
                  />
                  <Route
                    path="/timelesstech-demo/:ProviderId/:GameId"
                    element={<TimelessTech demo={true} />}
                  />

                  <Route
                    path="/my-account/"
                    element={<Navigate to="/my-account/profile" />}
                  />

                  <Route path="/my-account/:option" element={<MyAccount />} />



                </>
              )
            }

          </Routes>
        </>
      )}
    </Translation>
  );
};
const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;

  return {
    user,
    loggedIn,
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
    UpdateLiveGame: (data) => dispatch(gameAction.UpdateLiveGame(data)),
    UpdateLiveGameProviders: (data) =>
      dispatch(gameAction.UpdateLiveGameProviders(data)),
    UpdateLoadingStatus: (data) =>
      dispatch(gameAction.UpdateLoadingStatus(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Gamer);
